import { Directive, inject, Inject, Optional } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';

import { ObrazacUnosaService } from '@app/components/fast-data-entry/service/obrazac-unosa.service';
import {
  DataSource,
  Item,
  ItemView,
  ItemViewProviderDirective,
  IViewStateTransform,
  ListViewProviderDirective,
  VIEW_STATE_TRANSFORM_SERVICE_TOKEN,
  ViewResultListener
} from '@ntap/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[customItemViewProvider]',
  exportAs: 'customItemViewProvider'
})
export class CustomItemViewProviderDirective<
  V extends ItemView
> extends ItemViewProviderDirective<V> {
  private itemSubject = new BehaviorSubject<any>(null);
  private _mojitem$: Observable<Item> = this.itemSubject.asObservable();

  private fastDataEntryService = inject(ObrazacUnosaService);

  constructor(
    @Optional() protected override resultListener: ViewResultListener,
    protected override dataSource: DataSource,
    @Optional()
    public override listViewProvider: ListViewProviderDirective<any>,
    @Inject(VIEW_STATE_TRANSFORM_SERVICE_TOKEN)
    viewStateTransformService: IViewStateTransform
  ) {
    super(
      resultListener,
      dataSource,
      listViewProvider,
      viewStateTransformService
    );
    this.addSubscription(
      this.fastDataEntryService.selectEntryTemplate$
        .pipe(
          tap((e) => {
            this.viewName = e.name;
          })
        )
        .subscribe()
    );
  }
  setItem(item: Item): void {
    this.itemSubject.next(item);
  }

  override get item$(): Observable<Item> {
    return this._mojitem$;
  }
}
